/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "social-twitter-square-f570af02--sprite",
  "use": "social-twitter-square-f570af02--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"social-twitter-square-f570af02--sprite\">\r\n  <defs>\r\n    <clipPath id=\"social-twitter-square-f570af02--sprite_clip-path\">\r\n      <rect width=\"19\" height=\"15.441\" fill=\"none\" />\r\n    </clipPath>\r\n    <clipPath id=\"social-twitter-square-f570af02--sprite_clip-Social_Twitter\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"social-twitter-square-f570af02--sprite_Social_Twitter\" clip-path=\"url(#social-twitter-square-f570af02--sprite_clip-Social_Twitter)\">\r\n    <g id=\"social-twitter-square-f570af02--sprite_Group_19866\" data-name=\"Group 19866\">\r\n      <g id=\"social-twitter-square-f570af02--sprite_Group_19865\" data-name=\"Group 19865\" transform=\"translate(0 0)\">\r\n        <rect id=\"social-twitter-square-f570af02--sprite_Rectangle_3070\" data-name=\"Rectangle 3070\" width=\"36\" height=\"36\" rx=\"18\" fill=\"#e0e7f4\" opacity=\"0\" />\r\n      </g>\r\n    </g>\r\n    <g id=\"social-twitter-square-f570af02--sprite_Component_3\" data-name=\"Component 3\" transform=\"translate(9 10)\" clip-path=\"url(#social-twitter-square-f570af02--sprite_clip-path)\">\r\n      <path id=\"social-twitter-square-f570af02--sprite_Path_2951\" data-name=\"Path 2951\" d=\"M850.054,280.3a11.016,11.016,0,0,0,11.091-11.091c0-.169,0-.337-.011-.5a7.931,7.931,0,0,0,1.945-2.018,7.778,7.778,0,0,1-2.239.614,3.912,3.912,0,0,0,1.714-2.156,7.813,7.813,0,0,1-2.475.946,3.9,3.9,0,0,0-6.643,3.555,11.067,11.067,0,0,1-8.035-4.073,3.9,3.9,0,0,0,1.207,5.2,3.87,3.87,0,0,1-1.765-.488c0,.016,0,.033,0,.05a3.9,3.9,0,0,0,3.127,3.822,3.894,3.894,0,0,1-1.76.067,3.9,3.9,0,0,0,3.642,2.707,7.822,7.822,0,0,1-4.841,1.669,7.953,7.953,0,0,1-.93-.054,11.036,11.036,0,0,0,5.975,1.751\" transform=\"translate(-844.079 -264.859)\" fill=\"currentColor\" />\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
